export default __webpack_public_path__ + "static/media/homedecor.bd650b3f.jpg";